{
	"title": "Product",
	"photos": {
		"label": "Foto's van {{name}}",
		"show": "Foto {{number}} tonen: {{alt}}",
		"none": "Nog geen foto"
	},
	"fit": {
		"fits": "Past op {{holder}}",
		"notFor": "Niet voor {{holder}}"
	},
	"price": {
		"perPieceInPack": "per {{noun}} in het pak van {{count}}"
	},
	"business": {
		"badge": "Zakelijk · jouw prijs",
		"yours": "Jouw prijs",
		"list": "Lijstprijs",
		"onAccount": "Betalen op rekening binnen {{term}}."
	},
	"packs": {
		"label": "Kies je pak",
		"count": "{{count}} stuks",
		"perPiece": "per {{noun}}",
		"save": "Bespaar {{percent}}%",
		"smallest": "Kleinste pak",
		"soldOut": "Uitverkocht"
	},
	"staffel": {
		"step": "Vanaf {{quantity}} stuks {{percent}}% korting"
	},
	"soldOut": {
		"title": "Uitverkocht",
		"packs": "Alle pakken zijn op.",
		"product": "Dit product is op.",
		"whatFits": "Bekijk wat wel past op {{holder}}",
		"category": "Bekijk de rest van {{category}}",
		"all": "Bekijk alle producten",
		"button": "Uitverkocht"
	},
	"delivery": {
		"today": "Vóór 17:00 besteld, vandaag verstuurd.",
		"remaining": "Bestel binnen {{hours}} uur en {{minutes}} min.",
		"remainingHours": "Bestel binnen {{hours}} uur.",
		"remainingMinutes": "Bestel binnen {{minutes}} min.",
		"later": "Nu besteld, {{day}} verstuurd.",
		"days": {
			"tomorrow": "morgen",
			"monday": "maandag",
			"tuesday": "dinsdag",
			"wednesday": "woensdag",
			"thursday": "donderdag",
			"friday": "vrijdag"
		},
		"shipping": "Verzenden {{rates}}.",
		"rate": "{{rate}} naar {{country}}",
		"freeFrom": "Gratis vanaf {{amount}}.",
		"freeFromTo": "Gratis naar {{country}} vanaf {{amount}}.",
		"noSubscription": "Geen abonnement nodig."
	},
	"sticky": {
		"pack": "Pak van {{count}}",
		"add": "In mand",
		"added": "In je mand",
		"addLabel": "In mand: {{name}}"
	},
	"below": {
		"fit": {
			"title": "Past op en niet voor",
			"fitsOne": "Past op de {{holder}}",
			"notForOne": "Niet voor de {{holder}}",
			"foot": "voetmaat {{size}}",
			"sizes": "die heeft {{pieces}} van {{sizes}}",
			"others": "andere wissers",
			"measuringTip": "Meettip."
		},
		"contents": {
			"title": "Wat zit erin",
			"quantity": "{{quantity}}×",
			"pieces": "{{pieces}} per verpakking"
		},
		"match": {
			"title": "Past bij je wisser",
			"forThese": "Voor deze {{pieces}}"
		},
		"facts": {
			"title": "Beschrijving en kenmerken",
			"caption": "Kenmerken",
			"size": "Maat",
			"count": "Aantal",
			"countValue_one": "{{count}} per pak",
			"countValue_other": "{{count}} {{pieces}} per pak",
			"material": "Materiaal",
			"for": "Voor {{pieces}}",
			"sku": "Artikelnummer",
			"ean": "EAN"
		},
		"reviews": {
			"title": "Reviews",
			"onlyBuyers": "Alleen kopers kunnen een review schrijven, via de uitnodiging per mail na levering.",
			"none": "Kocht je dit? Na levering krijg je een mail met een uitnodiging voor een review.",
			"more": "Meer reviews"
		}
	}
}
